<!-- IT资产维修流程 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'

	import {
		getRelation
	} from '@/api/employee'
	import {
		getDepartmentInfo
	} from '@/api/department'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				flowId:null,
				sendMessageData: Object.assign({},sendMessagetTemplate),
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.flowId = this.$route.query.flowId;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						var DepAssignment = true;
						var departFullName = "";
						await getDepartmentInfo(depart.id).then(res => {
							departFullName = res.Body.FullName;
						});
						
						that.templateData.TemplateContent.Controls.forEach(async (item) => {
							if (name == "申请部门") {
								if (item.Property.Title[0].Text == "请选择审批流程") {
									var departs = that.logInfo.fullName;
									var ApiDep = departFullName;
									var IsContinue = true;
									if (ApiDep.indexOf("按揭金融服务中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
										item.Config.Selector.Options[1].Value[0].Text = "汇瀚";
									}
									if (ApiDep.indexOf("华西区/原友信") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
										item.Config.Selector.Options[1].Value[0].Text = "原友信";
									}
									if (ApiDep.indexOf("华西区/四川中原物业顾问有限公司/非营业部") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
										item.Config.Selector.Options[1].Value[0].Text = "非营业部";
									}
									if (ApiDep.indexOf("住宅部") > -1 || ApiDep.indexOf("住宅行政支持组") > -1 || ApiDep.indexOf("住宅部支援中心") > -1) {
										if (that.logInfo.EmpNo == "SC15004802") {
											item.Value = "option-1600689940131"
											item.IsShow = false;
											item.Config.Selector.Options[0].Value[0].Text = "住宅部支援中心经理审批";
										} else if (departs.indexOf("住宅行政支持组") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
											item.Config.Selector.Options[1].Value[0].Text = "行政主任审批";
										} else {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "住宅部支援中心经理审批";
											item.Config.Selector.Options[1].Value[0].Text = "行政主任审批";
										}
									}
									if (ApiDep.indexOf("工商铺商业运营中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									}
									if (ApiDep.indexOf("房友圈") > -1) {
										
										if (departs.indexOf("华西区/房友圈") > -1) {
											item.Value = "option-1600689940131"
											item.IsShow = false;
											item.Config.Selector.Options[0].Value[0].Text = "房友圈部门经理总监审批";
										}
										if (departs.indexOf("华酉区/四川中原物业顾问有限公司/非营业部/职能中心/后勤房友圈") > -1 || departs.indexOf(
												"华西区/房友圈/非营业部/职能中心/后勤房友圈") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
											item.Config.Selector.Options[1].Value[0].Text = "房友圈总经理助理刘晴审批";
										}
										if (ApiDep.indexOf("房友圈") > -1 && !(departs.indexOf("华西区/房友圈") > -1)) {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "房友圈部门经理/总监审批";
											item.Config.Selector.Options[1].Value[0].Text = "房友圈总经理助理刘晴审批";
										}
									}
									if (ApiDep.indexOf("二级市场营运中心") > -1 || ApiDep.indexOf("代理") > -1) {
										var IsContinue = true;
										if (departs.indexOf("二级市场") > -1) {
											IsContinue = false;
											item.Value = "option-1600689940131"
											item.IsShow = false;
											item.Config.Selector.Options[0].Value[0].Text = "营运部总经理/副总经理审批";
										} 
										if (departs.indexOf("华西区/代理/非营业部/二级市场支援中心") > -1) {
											IsContinue = false;
											item.Value = "option-1600689940132"
											item.IsShow = false;
											item.Config.Selector.Options[1].Value[0].Text = "总经理助理唐媛审批";
										} 
										if(IsContinue) {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "营运部总经理/副总经理审批";
											item.Config.Selector.Options[1].Value[0].Text = "总经理助理唐媛审批";
										}
									}
									if (ApiDep == "华西区" || ApiDep.indexOf("华西区/华西区信息中心") > -1 ) {
										if (that.logInfo.EmpNo == "SC09120024") {
											var IsContinue = false;
											item.Value = "option-1600689940131"
											item.IsShow = false;
											item.Config.Selector.Options[0].Value[0].Text = "区域总裁助理聂丽娟审批";
										} 
										if (departs.indexOf("华西区信息中心") > -1) {
											var IsContinue = false;
											item.Value = "option-1600689940132"
											item.IsShow = false;
											item.Config.Selector.Options[1].Value[0].Text = "华西区信息中心经理";
										}
										if(IsContinue){
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "区域总裁助理聂丽娟审批";
											item.Config.Selector.Options[1].Value[0].Text = "华西区信息中心总经理审批";
										}
									}
								}
							}
						});
						dataVal.Values = [];
						dataVal.Values.push([depart.id, depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				getTemplateInfo(this.templateId).then(async response => {
					console.log("xxxxxxxxxxxxxxxxxxxxxxxxx");
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						// if (item.Property.Title[0].Text == "信息中心技术鉴定") {
						// 	item.IsShow = false;
						// }
						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.IsShow = false;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					// this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				this.sendMessageData.title = "IT资产维修申请";
				this.sendMessageData.toUser=["SC18008706","SC02120003"];
				this.sendMessageData.desc="申请人："+this.logInfo.EmpName;
				this.sendMessageData.url=document.location.hostname+"/ITAssetMaintenance?templateId=Bs7yoKnpdh88U4RsCy2b3nawV5FaB9TLbdi1uhwDZ&empNo="+this.logInfo.EmpNo;
				this.sendMessageData.template=this.templateData;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,1,this.logInfo.EmpName).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
				//提交
				// submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
				// 	this.Message({
				// 		message: '申请成功',
				// 		type: 'success',
				// 		duration: 3 * 1000
				// 	});
				// 	setTimeout(() => {
				// 		this.$router.push("/index");
				// 	}, 3000)
				// }).finally(() => {
				// 	isSubmit = false;
				// 	this.listLoading = false;
				// });
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
